const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  cartInterceptor: {
    update: 'cart-interceptor:update',
    add: 'cart-interceptor:add',
    change: 'cart-interceptor:change',
    clear: 'cart-interceptor:clear',
  },
  cartDrawerRendered: 'cart-drawer-rendered',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  filter: {
    changed: {
      empty: 'filter:changed:empty',
      notEmpty: 'filter:changed:not-empty',
    }
  },
  cartDrawer: {
    open: 'cart-drawer:open',
    close: 'cart-drawer:close',
  },
};
